import {each} from 'underscore';
import {dataLayerContentExtention} from './dataLayers';
import querySelectorAll from './querySelectorAll';

const body = document.querySelector('.js-menu-toggle');

const triggerOpenMenu = document.querySelector('.js-menu-toggle-open');
const triggerCloseMenu = document.querySelector('.js-menu-toggle-close');
const menucontainer = document.querySelector('.main-header__nav');

const triggerModal = document.querySelector('.js-menu-toggle-modal');
const modalContentSwitch = querySelectorAll('.js-modal-content-switch');
const modalContentSwitchTrigger = querySelectorAll('.js-modal-content-switch-trigger');

const triggerToggleDropdown = document.querySelector('header .js-dropdown-toggle'); // only the desktop one
const triggerLocaleToggleDropdown = document.querySelector('header .js-dropdown-locale-toggle'); // only the desktop one
const dropdownContainer = document.querySelector('.main-header__nav__account__dropdown');
const dropdownLocaleContainer = document.querySelector('.main-header__nav__locale__dropdown');

const triggersExpandCollapse = querySelectorAll('.js-expand-collapse-toggle');

const moduleStepToggle = querySelectorAll('.js-module-step-toggle');

const filterToggle = querySelectorAll('.js-filter-toggle');
const filterToggleTarget = document.querySelector('.js-filter-toggle-target');

const faqToggle = document.querySelectorAll('.js-faq-toggle');


function Toggle() {
    // Menu
    if (triggerOpenMenu) {
        triggerOpenMenu.addEventListener('click', (e) => {
            clickHandlerMenu(e, body);
        });

        triggerCloseMenu.addEventListener('click', (e) => {
            clickHandlerMenu(e, body);
        });

        window.addEventListener('click', (e) => {
            if (!menucontainer.contains(e.target)
                && !triggerOpenMenu.contains(e.target)
                && body.classList.contains('active-menu')) {
                body.classList.toggle('active-menu');
            }
        });
    }

    // Login modal
    if (triggerModal) {
        triggerModal.addEventListener('click', (e) => {
            clickHandlerMenu(e, body);
        });
    }

    // Modal content switch
    // Hides first modal content en shows the next sibling
    if (modalContentSwitch) {
        each(modalContentSwitchTrigger, (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                el.closest('.js-modal-content-switch').classList.add('hidden');
                el.closest('.js-modal-content-switch').nextElementSibling.classList.remove('hidden');
            });
        });
    }

    // Account
    if (triggerToggleDropdown) {
        triggerToggleDropdown.addEventListener('click', (e) => {
            e.preventDefault();

            triggerToggleDropdown.classList.toggle('open');
        });

        window.addEventListener('click', (e) => {
            if (!dropdownContainer.contains(e.target)
                && !triggerToggleDropdown.contains(e.target)
                && triggerToggleDropdown.classList.contains('open')) {
                triggerToggleDropdown.classList.toggle('open');
            }
        });
    }
    // Locale
    if (triggerLocaleToggleDropdown) {
        triggerLocaleToggleDropdown.addEventListener('click', (e) => {
            e.preventDefault();

            triggerLocaleToggleDropdown.classList.toggle('open');
        });

        window.addEventListener('click', (e) => {
            if (!dropdownLocaleContainer.contains(e.target)
                && !triggerLocaleToggleDropdown.contains(e.target)
                && triggerLocaleToggleDropdown.classList.contains('open')) {
                triggerLocaleToggleDropdown.classList.toggle('open');
            }
        });
    }


    // Expand-collapse
    // fe. programme summary pp, FAQ
    if (triggersExpandCollapse) {
        each(triggersExpandCollapse, (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                if (faqToggle && !el.classList.contains('open')) { // only send push when opening, not closing
                    dataLayerContentExtention(el.innerText);
                }

                el.classList.toggle('open');
            });
        });
    }

    // Module Step Toggle
    // inside progress overview aside
    if (moduleStepToggle) {
        each(moduleStepToggle, (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                el.classList.toggle('open');
            });
        });
    }

    // Filter
    // fe. search mobile
    if (filterToggle) {
        each(filterToggle, (el) => {
            el.addEventListener('click', (e) => {
                e.preventDefault();

                filterToggleTarget.classList.toggle('open');
            });
        });
    }
}

function clickHandlerMenu(e) {
    e.preventDefault();

    body.classList.toggle('active-menu');
}


export default Toggle;



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/Toggle.js